// ============================================================================
// ROOM ENDPOINTS
// ============================================================================
// Endpoint definitions for Room module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for room endpoints (matches RoomController route)
 */
const BASE_PATH = '/Room';

/**
 * Room Endpoints
 */
export const roomEndpoints = {
  /**
   * Get all rooms (paginated)
   * GET /Room
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get room by ID
   * GET /Room/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get room by room number
   * GET /Room/number/:roomNumber
   */
  getByNumber: (roomNumber: string) => buildEndpointWithParams(`${BASE_PATH}/number/:roomNumber`, { roomNumber }),

  /**
   * Create new room
   * POST /Room
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update room
   * PUT /Room/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete room
   * DELETE /Room/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Validate room number uniqueness
   * GET /Room/validate/number/:roomNumber?propertyId=&excludeId=
   */
  validateNumber: (roomNumber: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/number/:roomNumber`, { roomNumber }),
} as const;

/**
 * Export endpoints
 */
export default roomEndpoints;
